import { getFillClass, getUsagePercent } from '../helper/tariffHelper';

type TariffUsageBarProps = {
    label: string;
    used: number;
    limit: number;
    remainingLabel: string;
    formatValue?: (value: number) => string;
};

const TariffUsageBar = ({ label, used, limit, remainingLabel, formatValue }: TariffUsageBarProps) => {
    const percent = getUsagePercent(used, limit);
    const format = formatValue || ((value: number) => String(value));

    return (
        <div className="sidebar-tariff__usage">
            <div className="sidebar-tariff__usage-head">
                <span className="sidebar-tariff__usage-label">{label}</span>
                <span className="sidebar-tariff__usage-value">{format(used)} / {format(limit)}</span>
            </div>
            <div className="sidebar-tariff__track">
                <div
                    className={`sidebar-tariff__fill ${getFillClass(percent)}`}
                    style={{ width: `${percent}%` }}
                />
            </div>
            <div className="sidebar-tariff__remaining">{remainingLabel}</div>
        </div>
    );
};

export default TariffUsageBar;
